import type { ToolModule } from '../../core/modules/types'
import { SummaryView } from './view'

export const summaryModule: ToolModule = {
  id: 'summary',
  title: 'User Summary',
  description: 'For each credential you hold, see everything the backend knows about that user — agent profile, stock, Quality of Sales, or staff details.',
  requiresToken: true,
  View: SummaryView,
}
